<div class="plan-of-action-execute">
    <dw-container [options]="acsTestSelectionContainer"
        *ngIf="!currentAcsTestPortion && !inPrintMode && acsTestDetails?.length > 0">
        <div body>
            <div dwRow class="portion-summary-desktop">
                <div dwCol="3">

                </div>
                <div dwCol="2 label">
                    % Complete
                </div>
                <div dwCol="2  label">
                    Sections
                </div>
                <div dwCol="2  label">
                    Questions
                </div>
                <div dwCol="3  label">

                </div>
            </div>
            <div dwRow class="portion-summary-desktop" *ngFor="let acsTestDetail of acsTestDetails; let i = index">
                <div dwCol="3">
                    <button class="btn btn-secondary ml-1" (click)="print(acsTestDetail)" title="Export to PDF"
                        [disabled]="exporting">
                        <i class="fa fa-file-pdf"></i>

                        <i class="fa fa-spinner fa-spin ml-1 dw-orange" title="Exporting..."
                            *ngIf="exporting && exportingTestPortionId == acsTestDetail.acsTestPortion.AcsTestPortionId"></i>
                    </button>

                    {{acsTestDetail.acsTestPortion.AcsTestPortion}}
                </div>
                <div dwCol="2">
                    {{acsTestDetail.percentComplete}}%
                </div>
                <div dwCol="2">
                    {{acsTestDetail.sectionCount}}
                </div>
                <div dwCol="2">
                    {{acsTestDetail.questionsCompleted}} / {{acsTestDetail.questionCount}}
                </div>
                <div dwCol="3">
                    <button class="btn btn-success" (click)="goToAcsTestPortion(acsTestDetail)"
                        *ngIf="!isReadOnly()"
                        [hidden]="acsTestDetail.percentComplete!=0">Start</button>
                    <button class="btn btn-success" (click)="goToAcsTestPortion(acsTestDetail)"
                        [hidden]="acsTestDetail.percentComplete==0 || acsTestDetail.percentComplete == 100 ">Continue</button>
                    <button class="btn btn-success" (click)="goToAcsTestPortion(acsTestDetail)"
                        [hidden]="acsTestDetail.percentComplete!=100">Review</button>
                </div>
            </div>
            <div class="portion-summary-mobile">
                <article class="portion-card" *ngFor="let acsTestDetail of acsTestDetails">
                    <div class="portion-card-header">
                        <h3>{{acsTestDetail.acsTestPortion.AcsTestPortion}}</h3>
                        <button type="button" class="btn btn-secondary" (click)="print(acsTestDetail)"
                            title="Export to PDF" [disabled]="exporting"
                            [attr.aria-label]="'Export ' + acsTestDetail.acsTestPortion.AcsTestPortion + ' to PDF'">
                            <i class="fa fa-file-pdf" aria-hidden="true"></i>
                            <i class="fa fa-spinner fa-spin ml-1 dw-orange" title="Exporting..." aria-hidden="true"
                                *ngIf="exporting && exportingTestPortionId == acsTestDetail.acsTestPortion.AcsTestPortionId"></i>
                        </button>
                    </div>
                    <dl class="portion-card-metrics">
                        <div>
                            <dt>Complete</dt>
                            <dd>{{acsTestDetail.percentComplete}}%</dd>
                        </div>
                        <div>
                            <dt>Sections</dt>
                            <dd>{{acsTestDetail.sectionCount}}</dd>
                        </div>
                        <div>
                            <dt>Questions</dt>
                            <dd>{{acsTestDetail.questionsCompleted}} / {{acsTestDetail.questionCount}}</dd>
                        </div>
                    </dl>
                    <div class="portion-card-actions">
                        <button type="button" class="btn btn-success" (click)="goToAcsTestPortion(acsTestDetail)"
                            *ngIf="!isReadOnly() && acsTestDetail.percentComplete == 0">Start</button>
                        <button type="button" class="btn btn-success" (click)="goToAcsTestPortion(acsTestDetail)"
                            *ngIf="acsTestDetail.percentComplete != 0 && acsTestDetail.percentComplete != 100">Continue</button>
                        <button type="button" class="btn btn-success" (click)="goToAcsTestPortion(acsTestDetail)"
                            *ngIf="acsTestDetail.percentComplete == 100">Review</button>
                    </div>
                </article>
            </div>
        </div>

        <dw-loading [show]="exporting" text="Exporting PDF"></dw-loading>
    </dw-container>

    <ng-container *ngIf="currentAcsTestPortion && !inPrintMode">
        <dw-container [options]="acsTestPortionContainer">
            <span header>{{currentAcsTestPortion.acsTestPortion.AcsTestPortion}}</span>
            <div body>

                <ng-container *ngIf="showAllSections">
                    <div class="button-bar-simple execution-toolbar hide-print">
                        <div class="pull-left">
                            <ng-container *ngTemplateOutlet="autoSaveTemplate"></ng-container>
                        </div>
                        <div class="pull-right ml-1 execution-toggles">
                            <ng-container *ngTemplateOutlet="missedCodesToggle"></ng-container>
                            <ng-container *ngIf="showAllSectionsToggle">
                                <ng-container *ngTemplateOutlet="sectionToggle"></ng-container>
                            </ng-container>
                        </div>
                        <div class="pull-right">
                            <button class="btn btn-primary" (click)="complete()">{{isReadOnly() ? 'Return' : 'Save and Return'}}</button>
                        </div>


                    </div>
                    <ng-container *ngFor="let currentSection2 of currentTestSections; let i = index">

                        <app-plan-of-action-execute-section [planOfAction]="planOfAction"
                            [planOfActionSection]="currentSection2" [sectionTypes]="sectionTypes"
                            [acsCodeStatuses]="acsCodeStatuses"
                            [showOnlyMissedAcsCodes]="showOnlyMissedAcsCodes && hasAcsCodeSections"
                            [planOfActionQuestionResults]="planOfActionQuestionResults"
                            (resultChange)="resultChange($event)"
                            [readOnly]="isReadOnly()"
                            [useTitleOnlyContainer]="true"></app-plan-of-action-execute-section>

                    </ng-container>
                    <div class="button-bar-simple  hide-print">
                        <div class="pull-right">
                            <button class="btn btn-primary  pull-right" (click)="complete()">{{isReadOnly() ? 'Return' : 'Save and Return'}}</button>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!showAllSections">
                    <div class="button-bar-simple execution-toolbar hide-print">
                        <div class="pull-left" *ngIf="!showAllSections">
                            <button class="btn btn-primary" (click)="previousSection()" *ngIf="hasPrevious"
                                title="Previous and Save">Previous</button>
                        </div>
                        <div class="pull-left section-navigation">
                            <dw-search-select-lookup [overrideValues]="sectionList"
                                [options]="{displayStyle: 'enhanced', showLink: false}"
                                [(ngModel)]="selectedSectionId" [ngModelOptions]="{standalone: true}"
                                placeholder="Select a section" [alwaysShowFilter]="true"
                                [showClear]="true" [showBlankOption]="false"></dw-search-select-lookup>
                            <button type="button" class="btn btn-primary" (click)="goToSection()">
                                Go to Section</button>
                        </div>
                        <div class="pull-left">
                            <ng-container *ngTemplateOutlet="autoSaveTemplate"></ng-container>
                        </div>
                        <div class="pull-right">
                            <div class="pull-right ml-1 execution-toggles">
                                <ng-container *ngTemplateOutlet="missedCodesToggle"></ng-container>
                                <ng-container *ngIf="showAllSectionsToggle">
                                    <ng-container *ngTemplateOutlet="sectionToggle"></ng-container>
                                </ng-container>
                            </div>
                            <div class="pull-right">
                                <button class="btn btn-primary" (click)="stop()" *ngIf="hasNext">{{isReadOnly() ? 'Return' : 'Save and Return'}}</button>
                                <button class="btn btn-primary" (click)="complete()" *ngIf="!hasNext">{{isReadOnly() ? 'Return' : 'Save and Return'}}</button>
                                <button class="btn btn-success" (click)="nextSection()" *ngIf="hasNext"
                                    title="Next and Save">Next</button>
                            </div>
                        </div>
                    </div>
                    <app-plan-of-action-execute-section [planOfAction]="planOfAction"
                        [planOfActionSection]="currentSection" [sectionTypes]="sectionTypes"
                        [acsCodeStatuses]="acsCodeStatuses" [planOfActionQuestionResults]="planOfActionQuestionResults"
                        [showOnlyMissedAcsCodes]="showOnlyMissedAcsCodes && hasAcsCodeSections"
                        (resultChange)="resultChange($event)"
                        [readOnly]="isReadOnly()"
                        [useTitleOnlyContainer]="true"></app-plan-of-action-execute-section>

                    <div class="button-bar-simple  hide-print">
                        <div class="pull-left">
                            <button class="btn btn-primary" (click)="previousSection()" *ngIf="hasPrevious"
                                title="Previous and Save">Previous</button>
                        </div>
                        <div class="pull-right">
                            <button class="btn btn-primary  pull-right" (click)="stop()" *ngIf="hasNext">{{isReadOnly() ? 'Return' : 'Save and Return'}}</button>
                            <button class="btn btn-primary  pull-right" (click)="complete()" *ngIf="!hasNext">{{isReadOnly() ? 'Return' : 'Save and Return'}}</button>
                            <button class="btn btn-success pull-right" (click)="nextSection()" *ngIf="hasNext"
                                title="Next and Save">Next</button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </dw-container>
    </ng-container>
</div>

<ng-container *ngIf="inPrintMode">
    <ng-container *ngFor="let printTestDetail of printTestDetails">
        <!-- <dw-container [options]="printTestDetail.containerOptions">
            <span header>{{printTestDetail.acsTestPortion.AcsTestPortion}}</span>
            <div body>
               
            </div>
        </dw-container> -->

        <div class="print-page-header">
            <h1>{{printTestDetail.acsTestPortion.AcsTestPortion}}</h1>

            <ng-container *ngFor="let currentSection2 of printTestDetail.sections; let i = index; trackBy: trackBySectionId">
                <div dwRow>
                    <div dwCol="12">
                        <app-plan-of-action-execute-section [planOfAction]="planOfAction"
                            [planOfActionSection]="currentSection2" [sectionTypes]="sectionTypes"
                            [acsCodeStatuses]="acsCodeStatuses" [inPrintMode]="inPrintMode"
                            [planOfActionQuestionResults]="planOfActionQuestionResults"
                            (resultChange)="resultChange($event)"
                            [readOnly]="true"
                            [useTitleOnlyContainer]="true"></app-plan-of-action-execute-section>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-container>

<ng-template #sectionToggle>
    <div class="btn-group btn-group-toggle section-view-toggle" data-toggle="buttons">
        <label class="btn btn-primary" [ngClass]="{active : showAllSections}" title="Show All Sections">
            <i class="fa fa-boxes"></i> <input type="radio" name="manageSections2" [(ngModel)]="showAllSections"
                [value]="true" id="option1" autocomplete="off" checked>
        </label>
        <label class="btn btn-primary" [ngClass]="{active : !showAllSections}" title="Show Single Section">
            <i class="fa fa-box"></i> <input type="radio" name="manageSections2" [(ngModel)]="showAllSections"
                [value]="false" id="option2" autocomplete="off">
        </label>
    </div>
    <!-- <div class="btn-group btn-group-toggle mb-2 mt-1 pull-right" data-toggle="buttons">
        <label class="btn btn-primary" [ngClass]="{active : autoSave}" title="Show All Sections">
            <i class="fa fa-save" [ngClass]="{ 'dw-green': autoSave, 'dw-red': !autoSave }"></i> <input type="check" name="manageSections2" [(ngModel)]="autoSave"
                [value]="true" id="option1" autocomplete="off" checked> 
        </label>
    </div> -->
</ng-template>

<ng-template #missedCodesToggle>
    <dw-yesno *ngIf="hasAcsCodeSections" class="missed-codes-toggle" [ngModel]="!showOnlyMissedAcsCodes"
        (ngModelChange)="showOnlyMissedAcsCodes = !$event"
        [ngModelOptions]="{standalone: true}" [options]="missedAcsCodeToggleOptions">
    </dw-yesno>
</ng-template>


<ng-template #autoSaveTemplate>
    
    <div [hidden]="!showAutoSaveMessage || isReadOnly()" class="auto-save-text pull-left"><i [ngClass]="autoSaveIcon"></i> {{autoSaveMessage}}</div>

    <div class="dw-pills pull-left" [hidden]="isReadOnly()">
    <div class="dw-pill active" [hidden]="resultsToSave.length == 0 || false"><i class="fa fa-save2"></i> {{resultsToSave.length}} Pending Autosave</div></div>

</ng-template>
